import React from 'react';
import DigitalClock from './component/DigitalClock';
import './component/App.css'

function App() {
  return (
    <>
      <DigitalClock/>
    </>
  );
}

export default App;
